import { render, staticRenderFns } from "./products.vue?vue&type=template&id=f139faa2&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"
import style0 from "./products.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Option: require('/home/runner/work/myody_front/myody_front/components/option/Option.vue').default,Select: require('/home/runner/work/myody_front/myody_front/components/select/Select.vue').default,Form: require('/home/runner/work/myody_front/myody_front/components/form/Form.vue').default,MobileProduct: require('/home/runner/work/myody_front/myody_front/components/mobile/MobileProduct.vue').default,MobileProductCard: require('/home/runner/work/myody_front/myody_front/components/mobile/MobileProductCard.vue').default,MobileGoodsItem: require('/home/runner/work/myody_front/myody_front/components/mobile/goodsItem.vue').default})
